import { Body1, Title1 } from '@ui/Typography/Typography'

import { Box } from '@shared/components/Box'

import styles from './MorePerks.module.scss'

interface MorePerksProps {
  title: string
  body: string
}

export const MorePerks: React.FC<MorePerksProps> = ({ title, body }) => {
  return (
    <Box flex direction='column' gap='x16' className={styles.morePerks}>
      <Title1 semibold>{title}</Title1>
      <Body1 isParagraph color='text-med-em'>
        {body}
      </Body1>
    </Box>
  )
}
